import React from 'react';
export function TopBar() {
  return <div className="sticky top-0 z-50 w-full bg-cream-light/90 backdrop-blur-md border-b border-cream-dark py-3 px-4 text-center shadow-sm pt-[6px] pb-[6px]" data-id="element-321">
      <p className="font-serif text-carbon tracking-wide text-[12px] font-[700]" data-id="element-322">
        <span className="mr-2" data-id="element-323">🍪</span> BIBLIOTECADIGITAL.ONLINE™
      </p>
    </div>;
}